"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importDefault(require("react"));
var Card_1 = require("../Card");
var Spinner_1 = require("../Spinner");
require("./StatBar.scss");
function getColumnClass(colCount) {
    if (colCount === 1) {
        return 'w-full';
    }
    if (colCount === 2) {
        return 'w-1/2';
    }
    if (colCount === 3) {
        return 'w-1/3';
    }
    if (colCount === 4) {
        return 'w-1/4';
    }
    if (colCount === 5) {
        return 'w-1/5';
    }
    return 'w-1/6';
}
var StatBar = function (props) {
    var stats = props.stats;
    var filteredStats = stats.filter(function (stat) { return stat && stat.label; }).slice(0, 6);
    var colClasses = getColumnClass(filteredStats.length);
    return (react_1.default.createElement(Card_1.Card, { inverted: true, size: Card_1.CardSize.SM },
        react_1.default.createElement("div", { className: "statbar" }, filteredStats.map(function (stat, index) {
            return stat && (react_1.default.createElement("div", { key: "stat-" + (stat.key || index), className: colClasses + " text-white px-4 h-full flex flex-col justify-between" },
                react_1.default.createElement("div", { className: "text-sm font-medium text-white mb-1" }, stat.label),
                react_1.default.createElement("div", { className: classnames_1.default('font-bold leading-snug text-5xl relative flex-grow', {
                        'text-red': stat.state === 'danger',
                        'text-blue': stat.state === 'success',
                    }) },
                    stat.loading ? ' ' : stat.number,
                    stat.loading && (react_1.default.createElement("div", { className: "absolute top-0 left-0" },
                        react_1.default.createElement(Spinner_1.SpinnerInverted, null)))),
                react_1.default.createElement("div", null,
                    react_1.default.createElement("div", { className: classnames_1.default('font-medium text-xs rounded-full inline', 'leading-none py-1 px-2', {
                            'opacity-0': stat.loading || !stat.secondaryNumber,
                            'text-white bg-red': stat.secondaryState === 'danger',
                            'text-white bg-blue': stat.secondaryState === 'success',
                            'text-blue bg-blue-light': !stat.secondaryState,
                        }) },
                        stat.secondaryNumber,
                        stat.secondaryNumberAppend && (react_1.default.createElement("span", null, " " + stat.secondaryNumberAppend))))));
        }))));
};
exports.default = StatBar;
//# sourceMappingURL=StatBar.js.map